import { Box, Typography } from '@mui/material'
import React from 'react'
import { useTheme } from '@mui/material/styles'
import Button from '@mui/material/Button'

function FilterHeaderSection(props: {
  title?: string
  onClearSection?: () => void
  onClearText?: string
  rightSlot?: React.ReactNode
  middleSlot?: React.ReactNode
}) {
  const { title, onClearSection, rightSlot, middleSlot } = props

  const theme = useTheme()

  return (
    <Box
      p={1}
      sx={{ backgroundColor: theme.palette.background.custom3, opacity: 0.9, height: 40 }}
      display={'flex'}
      justifyContent={'space-between'}
      alignItems={'center'}
    >
      <Typography variant="body1" color={'textPrimary'}>
        {title}
      </Typography>
      {onClearSection && (
        <Button onClick={() => onClearSection()} color={'primary'}>
          {props.onClearText || 'Clear'}
        </Button>
      )}
      {middleSlot && middleSlot}
      <Box sx={{ display: 'flex', alignItems: 'center' }}>{rightSlot && rightSlot}</Box>
    </Box>
  )
}

export default FilterHeaderSection
